export default __webpack_public_path__ + "static/media/Animals-19.1c867759.png";